import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { endpoints } from "./endpoints";
import { environment } from "environments/environment";

@Injectable({ providedIn: 'any' })

export class apiService {
    getGeneralPreferences() {
        throw new Error('Method not implemented.');
    }
    constructor(private httpClient: HttpClient, private endPoints: endpoints) { }

    getLanguages(): Observable<any> {
        return this.httpClient.get(environment.API_URL + this.endPoints.getLanguages);
    }

    getCurrencies(): Observable<any> {
        return this.httpClient.get(environment.API_URL + this.endPoints.getCurrencies);
    }

    getSocialMedia(): Observable<any> {
      return this.httpClient.get(environment.API_URL + this.endPoints.getSocialMedia);
    }

    getBookings(page: number, itemsPerPage: number): Observable<any> {
      const url = `${environment.API_URL + this.endPoints.getBookings}?page=${page}&per_page=${itemsPerPage}`;
      return this.httpClient.get(url);
    }

    getBookingDetail(booking_id: number): Observable<any> {
      const url = `${environment.API_URL + this.endPoints.getBookingDetail}?booking_id=${booking_id}`;
      return this.httpClient.get(url);
    }

    getDownloadApp(languageCode: string): Observable<any> {
      const url = environment.API_URL + this.endPoints.getDownloadApp;

      // Include languageCode in the URL as a query parameter
      const fullUrl = `${url}?languageCode=${languageCode}`;

      return this.httpClient.get(fullUrl);
    }

    getTranslation(code: any): Observable<any> {
        return this.httpClient.get(environment.API_URL + this.endPoints.getLanguageTranslate + '?code=' + code);
    }

    getFeaturedFlight(page: number, itemsPerPage: number, currencyCode: string): Observable<any> {
        const url = `${environment.API_URL}${this.endPoints.getFeaturedFlight}?page=${page}&itemsPerPage=${itemsPerPage}&currencyCode=${currencyCode}`;
        return this.httpClient.get(url);
    }


    getHomeBanner(code: any): Observable<any> {
        const languageCode = localStorage.getItem('languageCode') || 'defaultLanguageCode'; // Use a default value if not found

        return this.httpClient.get(
            `${environment.API_URL}${this.endPoints.getHomeBanner}?language_code=${languageCode}`
        );
    }

    searchAirport(search: any): Observable<any> {
        return this.httpClient.get(environment.API_URL + this.endPoints.searchAirport + '?search=' + search);
    }

    searchFlight(body: any, header: any): Observable<any> {
        return this.httpClient.post(environment.API_URL + this.endPoints.searchFlight, body, header);
    }

    getCancellationData(body: any, header: any): Observable<any> {
        return this.httpClient.post(environment.API_URL + this.endPoints.getCancellationData, body, header);
    }

    getAmenitiesData(body: any, header: any): Observable<any> {
        return this.httpClient.post(environment.API_URL + this.endPoints.getAmenitiesData, body, header);
    }

    getGeneral(): Observable<any> {
        return this.httpClient.get(environment.API_URL + this.endPoints.getGeneral);
    }

    getFlightDetail(body: any, header: any): Observable<any> {
        return this.httpClient.post(environment.API_URL + this.endPoints.getFlightData, body, header);
    }

    createPayment(body: any, header: any): Observable<any> {
        return this.httpClient.post("https://eu-test.oppwa.com/v1/checkouts", body, header);
    }

    processPayment(checkoutId: any): Observable<any> {
        return this.httpClient.get("https://eu-test.oppwa.com/v1/checkouts/" + checkoutId + "/payment");
    }

    bookFlight(body: any, header: any): Observable<any> {
        return this.httpClient.post(environment.API_URL + this.endPoints.bookFlight, body, header);
    }

    getHotelAutoSearch(query: string, languageCode: string, headers: any): Observable<any> {
      return this.httpClient.post(
        environment.API_URL + this.endPoints.getHotelAutoSearch + '?search=' + query + '&languageCode=' + languageCode,
        {},
        { headers }
      );
    }

    getHotelAvailability(data: any, headers: any): Observable<any> {
      const requestData = {
        ...data,
      };
      return this.httpClient.post(
        environment.API_URL + this.endPoints.getHotelAvailability, requestData, { headers }
      );
    }

    getHotelDetails(data: any, headers: any): Observable<any> {
      const requestData = {
        ...data,
      };
      return this.httpClient.post(
        environment.API_URL + this.endPoints.getHotelDetails, requestData, { headers }
      );
    }

    getCountryList(search: string, per_page: number): Observable<any> {
        return this.httpClient.get(environment.API_URL + this.endPoints.getCountryList + '?search=' + search + '&per_page=' + per_page);
    }

    getStateList(country: string, searchText: string): Observable<any> {
        return this.httpClient.get(environment.API_URL + this.endPoints.getStateList + '?country_code=' + country + '&state_name=' + searchText);
    }

    getCityList(country: string, searchText: string): Observable<any> {
        return this.httpClient.get(environment.API_URL + this.endPoints.getCityList + '?country_code=' + country + '&city_name=' + searchText);
    }

    customerLogin(body: any, header: any): Observable<any> {
        return this.httpClient.post(environment.API_URL + this.endPoints.customerLogin, body, header);
    }

    customerSignup(body: any, header: any): Observable<any> {
        return this.httpClient.post(environment.API_URL + this.endPoints.customerSignUp, body, header);
    }

    sendVerificationOTP(body: any, header: any): Observable<any> {
        return this.httpClient.post(environment.API_URL + this.endPoints.sendVerificationOTP, body, header);
    }

    verifyOTP(body: any, header: any): Observable<any> {
        return this.httpClient.post(environment.API_URL + this.endPoints.verifyOTP, body, header);
    }

    getPageCode(): Observable<any> {
        console.log('this.endPoints.getPageCodes', this.endPoints.getPageCodes);
        return this.httpClient.get(environment.API_URL + this.endPoints.getPageCodes);
    }

    getPageContent(pageCode: string, languageCode: string): Observable<any> {
        return this.httpClient.get(environment.API_URL + this.endPoints.getPages + '?page_code=' + pageCode + '&language_code=' + languageCode);
    }

    sendForgotPwdOTP(body: any, header: any): Observable<any> {
        return this.httpClient.post(environment.API_URL + this.endPoints.sendForgotPwdOTP, body, header);
    }

    verifyForgotPwdOTP(body: any, header: any): Observable<any> {
        return this.httpClient.post(environment.API_URL + this.endPoints.verifyForgotPwdOTP, body, header);
    }

    resetPassword(body: any, header: any): Observable<any> {
        return this.httpClient.post(environment.API_URL + this.endPoints.resetPassword, body, header);
    }

    getApiLogin(username: string, password: string): Observable<any> {
      const credentials = {
        username: username,
        password: password
      };

      return this.httpClient.post(environment.API_URL + this.endPoints.getApiLogin, credentials);
    }

    // private apiLoginToken = localStorage.getItem('apiLoginToken');

    getTokenValidity(tokenID: any, header: any): Observable<any> {
      return this.httpClient.get(environment.API_URL + this.endPoints.getTokenValidity + '?tokenId=' + tokenID, { headers: header });
    }

    getRefreshToken(tokenID: any): Observable<any> {
      console.log('refresh-token')
      return this.httpClient.get(environment.API_URL + this.endPoints.getRefreshToken + '?tokenId=' + tokenID);
    }

    getArabicCountries(language_Code: string): Observable<any> {
        return this.httpClient.get(environment.API_URL + this.endPoints.getArabiCountries + '?language_code=' + language_Code);
    }

    getGeoLocationByIP(header: any): Observable<any> {
        return this.httpClient.post(environment.API_URL + this.endPoints.getGeoLocationByIP, null, header);
    }



}
